const dotToComma = (value) => {
  // return String(value ?? 0).replace(".", ",");
  return parseFloat(String(value).replace(/\s/g, "").replace(",", "."));
};

export default dotToComma;
